import { getInfo, TruncateWithTooltipFormatter } from "@Components/Grid/components/Table/formatters";

export default function UserFormatter({ info }) {
  const { row } = getInfo(info)
  const { id, first_name } = row.user || {}

  if (!id && !first_name) {
    return "--"
  }

  return <TruncateWithTooltipFormatter value={`[#${id}] - ${first_name}`} />
}
